<div class="close">
    <button (click)="close()" [attr.aria-label]="'BUTTON.CLOSE' | translate">
        <app-svg use="close" aria-hidden="true"></app-svg>
    </button>
</div>
<div class="language-overlay">
    <h1>{{ 'LANGUAGE_MENU.TITLE' | translate }}</h1>
    <button *ngFor="let lang of languages"
            [class.selected]="lang === currentLanguage"
            (click)="setLanguage(lang)">
        <app-svg [use]="lang.code" aria-hidden="true"></app-svg>
        <span>{{ lang.name }}</span>
    </button>
</div>
